var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEsib(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:52149)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.001 0.000976562C24.8375 0.000976562 32.0009 7.16447 32.0009 16.001C32.0009 24.8375 24.8375 32.0009 16.001 32.0009C7.16447 32.0009 0.000976562 24.8375 0.000976562 16.001",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6526 7.11116H29.3053C28.4063 5.76822 27.3093 4.56948 26.0561 3.5556H15.6526V7.11116Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6526 14.2222H31.9016C31.7652 12.9894 31.4889 11.7989 31.0887 10.6667H15.6526V14.2222Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.91175 21.3333H31.0883C31.4884 20.2011 31.7648 19.0106 31.9012 17.7777H0.098877C0.235127 19.0106 0.511501 20.2012 0.91175 21.3333V21.3333Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.94412 28.4444H26.0556C27.3086 27.4306 28.4058 26.2317 29.3048 24.8889H2.69507C3.59407 26.2317 4.69106 27.4305 5.94412 28.4444V28.4444Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 0.000976562C7.16349 0.000976562 -6.24995e-05 7.16446 4.08967e-10 16.0011C3.65162 16.0009 7.16349 16.0011 16 16.0011L16 0.000976562Z",
    fill: "#4A1F63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2172 8.34779V9.7391H12.5216V8.34779H11.1303V9.7391H10.4346V6.95648H7.65202V9.7391H6.95633V8.34779H5.56509V9.7391H4.8694V8.34779H3.47803V12.5217H14.6085V8.34779H13.2172Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:52149"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsib);
export default __webpack_public_path__ + "static/media/ESIB.247eb8b6.svg";
export { ForwardRef as ReactComponent };